import React, { useEffect, useRef, useState } from 'react';
import Hero from '../modules/Hero/Hero';
import globals from '../globals';
import MobileFleetPlan from '../modules/mobileFleet/MobileFleetPlan';
import FleetPlan from '../modules/mobileFleet/FleetPlan';
import BusinessNeed from '../modules/mobileFleet/BusinessNeed';
import thingsToKnow from "../../../data/mobile-fleet/thingsToKnow.json";
import faqs from "../../../data/mobile-fleet/faqs.json";
import terms from "../../../data/mobile-fleet/terms.json";
import ThingsToKnow from "../modules/ThingsToKnow";
import MobileCharges from "../mobileFleet/MobileCharges";
import MobileInternationalRates from "../mobileFleet/MobileInternationalRates";
import MobileRoaming from "../mobileFleet/MobileRoaming";
import MobileCoverage from "../mobileFleet/MobileCoverage";
import ExpandableListModule from "../modules/ExpandableListModule";
import HelmetDefault from '../layout/HelmetDefault';

const MobileFleet = () => {

    const containerRef = useRef(null);
    const planRef = useRef(null);
    const [content, setContent] = useState({plans: [], mbbPlans: [], items: []});
    const [dataReceived, setDataReceived] = useState(false);

    useEffect(() => {
        fetch('/api/mobile-fleet/plan')
        .then(result => result.json())
            .then((result) => {                
            setContent(result);
            setDataReceived(true);
            globals.animatePageIn(containerRef.current);
        }).catch((error) => {
            console.log(error);
            setDataReceived(false);
        })
    }, [dataReceived]);

    const scrollTo = (e) => {
        e.preventDefault();
        planRef.current.scrollIntoView({ behavior: 'smooth', block: 'start'});
    }

    return (
        <div ref={containerRef} style={{opacity: 0}}>
            <HelmetDefault {...content}/>
            <Hero title={content.title} dataReceived={true}>
                <h2 className="mt-0">{content.subTitle}</h2>
                <ul className="m-0 pl-4 font-large">
                    {content.items.map((item, key) => {
                        return <li key={key} className="mb-3" dangerouslySetInnerHTML={{__html: item}} />;
                    })}
                </ul>
                <h5 className="mt-5 mb-0 bold">{content.subHeading1}</h5>
                <p className="m-0 font-medium">{content.subText1}</p>
                <h5 className="mt-5 mb-0 bold">{content.subHeading2}</h5>
                <div className="d-block">
                    <a className="view-btn mt-3 d-inline-block" href="#" onClick={scrollTo}>View plans</a>
                </div>
            </Hero>
            <div ref={planRef}>
                <MobileFleetPlan data={content} />
            </div>
            <FleetPlan data={content} />
            <BusinessNeed data={content} />
            <div className="sub-content">
                <div id="things-to-know">
                    <ThingsToKnow data={thingsToKnow} />
                </div>
                <MobileCharges />
                <MobileInternationalRates />
                <MobileRoaming />
                <MobileCoverage />
                <div className="faqs">
                    <ExpandableListModule data={faqs.data} title={faqs.title} description={faqs.description} />
                </div>
                <div className="terms">
                    <ExpandableListModule data={terms.data} title={terms.title} description={terms.description} />
                </div>
            </div>
        </div>
    )
}
export default MobileFleet


// WEBPACK FOOTER //
// ./resources/assets/js/pages/MobileFleet.js